<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height"
      show-summary
      :summary-method="TableFooter">
      <el-table-column
        prop="HesapAdi"
        label="Hesap">
      </el-table-column>
      <el-table-column
        prop="Taksit"
        label="Taksit"
        align="right"
        width="50">
      </el-table-column>
      <el-table-column
        prop="Kar"
        label="Kar"
        align="right"
        width="70">
      </el-table-column>
      <el-table-column
        prop="Tahsil"
        label="Tutar"
        align="right"
        width="100">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        AltToplam: null,
        data: null,
        Height: window.innerHeight - 195

      }
    },
    methods: {
      TableFooter() {
        const sums = [];
        sums[2] = this.AltToplam.Kar;
        sums[3] = this.AltToplam.Tahsil;
        return sums;
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_a/p/aipos'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.AltToplam = response.AltToplam;
              this.lo = false;
              if (this.Liste) this.data = true;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/aiBugunPos.vue